import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { HTTPService } from "src/app/services/http.service";
import { UserAuthenticationServices } from "src/app/services/user-authentication.services";
import { AcessUser } from "../acess-view.component";

@Component({
    selector: "app-instances-action-view",
    templateUrl: "./instances-action-view.component.html",
    styleUrls: ["./instances-action-view.component.scss"],
    standalone: false
})
export class InstancesActionViewComponent implements OnChanges {

  @Input() user: AcessUser;

  loadingDataInstance: boolean = false;
  loadingDataAction: boolean = false;
  applyingAll: boolean = false;
  instanceInputFilter: string = "";
  actionsInputFilter: string = "";
  instanceAcessData = [];
  actionAcess = [];
  selectedInstance: any = null;
  selectedAction: any = null;
  private filterInstanceTimer: any;
  private filterActionTimer: any;

  constructor(
    private http: HTTPService,
    private uas: UserAuthenticationServices
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.user != null && this.user != null) {
      this.instanceAcessData = [];
      this.actionAcess = [];
      this.selectedInstance = null;
      this.selectedAction = null;
      this.actionsInputFilter = "";
      this.loadInstances();
    }
  }

  loadInstances() {
    let filter: any = this.instanceInputFilter;
    if (filter == null || filter.length == 0) {
      filter = null;
    }

    this.loadingDataInstance = true;
    this.uas.getInstancesAcessByUser(this.user.id, filter).then((x) => {
      this.instanceAcessData = this.uas.instancesAcessByUser;
      this.loadingDataInstance = false;
    });
  }

  loadActions() {
    let filter: any = this.actionsInputFilter;
    if (filter == null || filter.length == 0) {
      filter = null;
    }

    this.loadingDataAction = true;
    this.uas.getActionsByInstance(this.selectedInstance.id, this.user.id, filter).then((x) => {
      this.actionAcess = this.uas.actionsByInstances;
      this.loadingDataAction = false;
    });
  }

  selectInstance(instance) {
    if (this.selectedInstance === instance) {
      return;
    }

    this.selectedInstance = instance;
    this.selectedAction = null;
    this.actionAcess = [];
    this.loadActions();
  }

  updateFilterInstance() {
    clearTimeout(this.filterInstanceTimer);
    this.filterInstanceTimer = setTimeout(() => this.loadInstances(), 300);
  }

  clearFilterInstance() {
    this.instanceInputFilter = "";
    this.loadInstances();
  }

  updateFilterActions() {
    clearTimeout(this.filterActionTimer);
    this.filterActionTimer = setTimeout(() => this.loadActions(), 300);
  }

  clearFilterActions() {
    this.actionsInputFilter = "";
    this.loadActions();
  }

  changeAcessInstance(checked: boolean, type: string, item) {

    this.selectInstance(item);

    if (type == "V") {
      item.view = checked;
      this.saveInstanceAcess(item, checked, "CANVIEW");
    } else if (type == "A") {
      item.change = checked;
      this.saveInstanceAcess(item, checked, "CANCHANGE");
    } else if (type == "I") {
      item.insert = checked;
      this.saveInstanceAcess(item, checked, "CANINSERT");
    } else if (type == "D") {
      item.delete = checked;
      this.saveInstanceAcess(item, checked, "CANDELETE");
    } else if (type == "E") {
      item.export = checked;
      this.saveInstanceAcess(item, checked, "CANEXPORT");
    } else if (type == "C") {
      item.config = checked;
      this.saveInstanceAcess(item, checked, "CANCONFIG");
    }
  }

  changeAcessAction(checked: boolean, item) {
    this.selectedAction = item;
    item.enable = checked;

    let jsonSave: Object = {
      entityName: "Mktpmenuact",
      IDINSTANCE: this.selectedInstance.id,
      IDACTION: item.id,
      IDUSER: this.user.id,
      ENABLE: checked ? "S" : "N",
    };

    this.http.post(jsonSave, "JsonBrokerServices/save", true).subscribe();
  }

  private saveInstanceAcess(item, enable: boolean, propName: string) {
    let jsonSave: Object = {
      entityName: "Mktpdicacess",
      IDINSTANCE: item.id,
      IDUSER: this.user.id,
    };

    jsonSave[propName] = enable ? "S" : "N";

    this.http.post(jsonSave, "JsonBrokerServices/save", true).subscribe();
  }

  private saveInstanceAcessAsync(item, enable: boolean, propName: string): Promise<any> {
    return new Promise((resolve) => {
      let jsonSave: Object = {
        entityName: "Mktpdicacess",
        IDINSTANCE: item.id,
        IDUSER: this.user.id,
      };

      jsonSave[propName] = enable ? "S" : "N";

      this.http.post(jsonSave, "JsonBrokerServices/save", true).subscribe({
        next: (d) => resolve(d),
        error: (e) => resolve(null),
      });
    });
  }

  private propNameByType(type: string): string {
    switch (type) {
      case 'V': return 'CANVIEW';
      case 'A': return 'CANCHANGE';
      case 'I': return 'CANINSERT';
      case 'D': return 'CANDELETE';
      case 'E': return 'CANEXPORT';
      case 'C': return 'CANCONFIG';
    }
    return null;
  }

  /** todos os itens concedíveis da coluna estão marcados? */
  allChecked(prop: string, type: string): boolean {
    let grantable = this.instanceAcessData.filter((i) => !this.canPermite(i, type));
    return grantable.length > 0 && grantable.every((i) => !!i[prop]);
  }

  /** marca/desmarca a coluna inteira (só o que o usuário logado pode conceder) */
  async toggleAll(prop: string, type: string, checked: boolean) {
    if (this.applyingAll) {
      return;
    }

    let propName = this.propNameByType(type);
    this.applyingAll = true;
    this.loadingDataInstance = true;

    for (let item of this.instanceAcessData) {
      if (this.canPermite(item, type)) {
        continue;
      }
      if (!!item[prop] === checked) {
        continue;
      }

      item[prop] = checked;
      await this.saveInstanceAcessAsync(item, checked, propName);
    }

    this.applyingAll = false;
    this.loadingDataInstance = false;
  }

  canPermite(item, type: string): boolean {
    if (this.uas.user.profile == 'ADMIN') {
      return false;
    }

    if (type == "AC") {
      return item.cuenable ? false : true;
    }
    if (type == 'V') {
      return item.cuview ? false : true;
    }
    if (type == 'A') {
      return item.cuchange ? false : true;
    }
    if (type == 'I') {
      return item.cuinsert ? false : true;
    }
    if (type == 'D') {
      return item.cudelete ? false : true;
    }
    if (type == 'E') {
      return item.cuexport ? false : true;
    }
    if (type == 'C') {
      return item.cuconfig ? false : true;
    }

    return true;
  }
}
